exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".tag[_v-53796cb1]{border:1px solid #dadae0;border-radius:8px;text-decoration:none;background:#fff;margin-bottom:.5rem;padding:2px 4px;max-width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;font-size:14px;cursor:pointer}.tag span[_v-53796cb1]{color:#532aa2;font-family:sans-serif}.no-click[_v-53796cb1]{cursor:default!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-53796cb1&scoped=true!./~/sass-loader/dist/cjs.js!./~/vue-loader/lib/selector.js?type=style&index=0!./~/eslint-loader!./src/v3-components/HashTag/HashTag.vue
// module id = 285
// module chunks = 0